import { namespace } from "../Client/Namespace.ts";

((tooltips) => {
    tooltips.forEach(function (namespacedTooltips) {
        Object.assign(namespace(namespacedTooltips.TooltipNamespace), namespacedTooltips.Tooltips);
    });
})(typeof Tooltips != 'undefined' ? Tooltips : []);